export default "__VITE_ASSET__DrnMXL3C__"